import { render } from "./PackageIcon.vue?vue&type=template&id=abe11420&scoped=true&ts=true"
import script from "./PackageIcon.vue?vue&type=script&lang=ts"
export * from "./PackageIcon.vue?vue&type=script&lang=ts"

import "./PackageIcon.vue?vue&type=style&index=0&id=abe11420&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe11420"]])

export default __exports__